import React from "react";
import "../styles/Profile.css";
import Feed from "../components/Feed";
import Header from "../components/Header";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { Users } from "../data";
import { Link } from "react-router-dom";
import coverImage from '../Pvr.png'
import profileimage from '../profileimage.png'
import { FiveG } from "@mui/icons-material";

function Profile() {
    return (
    <div className="profile">
      <Header />
      <div className="fbIcon">
        <Link  to="/" style={{textDecoration:'none'}}>
        <img height='60px' src={"../assets/icon.png"} alt="" />
        </Link>
      </div>
      <div className="profileContainer">
        <div className="profileCenter">
          <div className="profileCenterTop">
            <img
              src={coverImage}
              alt="coverphoto"
              className="coverPhoto"
            />
            <button className="editCoverPhotoBtn">
              <CameraAltIcon />
              <b>Edit <span className="editPicText">Cover Photo</span></b>
            </button>
          </div>
          <div className="profileCenterDown">
            <div className="profileCenterDownCont">
              <div className="profilePhotoCont">
                <Link to='editprofile'><img
                  src={profileimage}
                  alt="profiephoto"
                  className="profilePhoto"
                /></Link>
                
              </div>
              <h4 className="profileUsername">
                Rajesh PV{" "}
                <p style={{ fontSize: "16px", margin: "0", opacity: "0.5" }}>
                  585 friends
                </p>
              </h4>
            </div>
          </div>
        </div> 

        <div className="profileBottom">
          <div className="profileBottomLeft">
            <div className="profileUserInfo">
              <h4 style={{ position:'absolute',top:'150px',marginLeft:'5px'}}>Bio</h4>
              <pre style={{marginTop:'20px'}}>
                {
`🌟  Funky soul in a digital world 
✨ Spreading good vibes and positive energy 
💃 Dance like everyone's watching, 
but you just don't care 
🎶 Music addict with a side of sass 
🌈 Embracing the weird and wonderful 
✌️ Living life one dance move at a time 

🎉✨ #StayFunky #DanceToYourOwnBeat`
                }
              </pre>
           
      <button type="button" className="editBioButton"><b>Edit Bio</b></button>
            </div>
            <div className="profileMutualFriendCont">
              <h4
                style={{
                  position: "absolute",
                  top: "-20px",
                  left: "5px",
                  margin: "0",
                }}
              >
                Mutual Friends
              </h4>
              {Users.filter(function (user) {
                return user.id > 1 && user.id <= 4;
              }).map(function (user) {
                return (
                  <div key={user.id} className="mutualFriend">
                    <img
                      className="profileMutualFriendImg"
                      src={user.profilePicture}
                      alt=""
                    />
                    <span className="profileMutualFriendName">
                      {user.username}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="profileBottomRight">
            <Feed className="profileFeed" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile;
